import React from 'react';
import { useNavigate } from "react-router-dom";
import hotelsData from '../data/hotels-data';
import '../css/destinations.css';

const DestinationCategory = () => {
  const navigate = useNavigate();

  return (
    <div className='destination-category-section'>
      <h1>Select Type of Destinations</h1>
      <div className="destination-category-container">
        {hotelsData.destinations.map((category, index) => (
          <div 
            key={index} 
            className={`destination-category-box destination-category-box${index + 1}`} 
            onClick={() => navigate(`/destinations/${category.category.toLowerCase()}`)}
          >
            <img src={category.image} alt={category.category} className="destination-category-image" />
            <div className="destination-category-box-content">
              <h2>{category.category}</h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DestinationCategory;
